import { applyMiddleware, createStore, compose } from 'redux'
import { rootReducer } from './reducer'
import thunk from 'redux-thunk'

const composeEnhancers =
	(typeof window !== 'undefined' &&
		window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] &&
		window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__']({
			maxAge: 20,
			trace: false,
			actionsBlacklist: ['handbook/SET_OPTIONS'],
		})) ||
	compose

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
